import { render, staticRenderFns } from "./JobTraineeshipSection.vue?vue&type=template&id=2e4e3a52&scoped=true&"
import script from "./JobTraineeshipSection.vue?vue&type=script&lang=js&"
export * from "./JobTraineeshipSection.vue?vue&type=script&lang=js&"
import style0 from "./JobTraineeshipSection.vue?vue&type=style&index=0&id=2e4e3a52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4e3a52",
  null
  
)

export default component.exports